var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0715 16C32.0715 24.8366 24.908 32 16.0715 32C7.23492 32 0.0714722 24.8366 0.0714722 16C0.0714722 7.16344 7.23492 0 16.0715 0C24.908 0 32.0715 7.16344 32.0715 16ZM4.08035 16C4.08035 22.6225 9.44896 27.9911 16.0715 27.9911C22.694 27.9911 28.0626 22.6225 28.0626 16C28.0626 9.37749 22.694 4.00888 16.0715 4.00888C9.44896 4.00888 4.08035 9.37749 4.08035 16Z",
    fill: "#F5F7FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0715 2.00605C16.0715 0.898138 16.9731 -0.0129541 18.0723 0.125593C19.9026 0.35629 21.6844 0.902466 23.337 1.74475C25.5872 2.89161 27.5339 4.55487 29.018 6.59847C30.502 8.64207 31.4812 11.008 31.8754 13.5026C32.2696 15.9973 32.0676 18.5498 31.2861 20.9514C30.5045 23.353 29.1655 25.5355 27.3785 27.3203C25.5916 29.1052 23.4076 30.4416 21.005 31.2204C18.6025 31.9991 16.0497 32.1981 13.5556 31.801C11.7238 31.5093 9.96181 30.9022 8.34629 30.0115C7.37607 29.4766 7.18336 28.2093 7.83542 27.3136C8.48747 26.4179 9.7371 26.2378 10.7289 26.7316C11.8151 27.2723 12.9806 27.6468 14.1864 27.8388C16.0552 28.1363 17.9678 27.9873 19.7679 27.4038C21.568 26.8203 23.2044 25.819 24.5432 24.4817C25.8821 23.1444 26.8853 21.5092 27.4709 19.7098C28.0565 17.9104 28.2078 15.9979 27.9124 14.1288C27.6171 12.2597 26.8834 10.4871 25.7715 8.95596C24.6596 7.4248 23.2011 6.17862 21.5151 5.31934C20.4272 4.76486 19.2646 4.38165 18.0682 4.17955C16.9758 3.99501 16.0715 3.11396 16.0715 2.00605Z",
    fill: "#BBC9D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPe);
export default __webpack_public_path__ + "static/media/pe.c3c536e9357a1222f8b101e8d72c155c.svg";
export { ForwardRef as ReactComponent };